import React, { useEffect, useState } from "react";
import closeIcon from "../../../assets/crossIcon.svg";
import searchIcon from "../../../assets/search-new-icon.svg";

const dummyMappedProcedures = Array.from({ length: 18 }).map((_, i) => ({
  id: i + 1,
  name:
    i % 2 === 0
      ? "Balloon Pulmonary / Aortic Valvotomy - Balloon Aortic Valvotomy"
      : "Pyogenic Meningitis",
}));

export default function RemoveMapping({ open, onClose, onProceed }) {
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);

  /* ================= BODY SCROLL LOCK + RESET ================= */
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";

    if (open) {
      setSelected([]);
      setSearch("");
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  if (!open) return null;

  /* ================= FILTERED LIST ================= */
  const filteredList = dummyMappedProcedures.filter((p) =>
    p.name.toLowerCase().includes(search.toLowerCase()),
  );

  const toggleItem = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const toggleAll = () => {
    if (isAllSelected) {
      setSelected([]);
    } else {
      setSelected(filteredList.map((p) => p.id));
    }
  };

  const isAllSelected =
    filteredList.length > 0 && selected.length === filteredList.length;

  /* ================= RENDER ================= */
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#00000066] px-4">
      <div className="relative w-full max-w-[1100px] bg-white rounded-[24px] px-10 py-8">
        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-12 right-6 bg-transparent border-none p-0"
        >
          <img src={closeIcon} alt="close" className="w-5 h-5" />
        </button>

        {/* Title */}
        <h2 className="text-center font-lufga font-medium text-[20px] text-black">
          Do you want to remove the mapping of non-freeze Procedures ?
        </h2>

        {/* Info Row */}
        <div className="flex items-center justify-between mt-6">
          <p className="font-lufga font-medium text-[28px] leading-[100%] tracking-[-0.04em] text-[#494949]">
            It will impact on the below Mapped Procedures
          </p>

          <span className="font-lufga text-[14px] text-[#38B58A]">
            Total Mapped Procedures ({filteredList.length})
          </span>
        </div>

        {/* Search */}
        <div className="mt-4 flex items-center gap-3 h-[72px] rounded-[54px] px-6 bg-[#FAFAFA] border-2 border-[#E6E6E6]">
          <img src={searchIcon} alt="search" className="w-6 h-6" />
          <input
            placeholder="Procedure Name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full bg-transparent outline-none border-none font-lufga text-[16px] tracking-[-0.04em] text-[#494949] placeholder-[#9A9A9A]"
          />
        </div>

        {/* List Container */}
        <div className="mt-6 rounded-[20px] border border-[#E6E6E6] p-6">
          <div className="flex items-center justify-between mb-3">
            <span className="font-lufga text-[14px]">
              Mapped Procedure Name
            </span>

            <button
              onClick={toggleAll}
              className="flex items-center gap-2 font-lufga text-[13px]"
            >
              <div
                className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                  isAllSelected
                    ? "bg-[#38B58A] border-[#38B58A]"
                    : "border-black"
                }`}
              >
                {isAllSelected && (
                  <span className="text-white text-[12px]">✓</span>
                )}
              </div>
              Select All
            </button>
          </div>

          {/* List */}
          <div className="max-h-[360px] overflow-y-auto rounded-[16px] border border-[#E6E6E6]">
            {filteredList.map((item, idx) => (
              <div
                key={item.id}
                className={`flex items-center gap-4 px-6 py-4 ${
                  idx % 2 === 0 ? "bg-white" : "bg-[#FAFAFA]"
                }`}
              >
                <button
                  onClick={() => toggleItem(item.id)}
                  className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                    selected.includes(item.id)
                      ? "bg-[#38B58A] border-[#38B58A]"
                      : "border-black"
                  }`}
                >
                  {selected.includes(item.id) && (
                    <span className="text-white text-[12px]">✓</span>
                  )}
                </button>

                <p className="font-lufga text-[14px] text-gray-800">
                  {item.name}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="flex justify-center mt-6">
          <button
            disabled={selected.length === 0}
            onClick={() => {
              onProceed(selected);
              onClose();
            }}
            className={`w-[292px] h-[88px] rounded-[52px] border font-lufga font-medium text-[14px] flex items-center justify-center transition
              ${
                selected.length === 0
                  ? "bg-[#F3B2B2] border-[#F3B2B2] text-white cursor-not-allowed"
                  : "border-[#E83D3D] text-black hover:opacity-90"
              }
            `}
            style={
              selected.length === 0
                ? {}
                : {
                    background:
                      "linear-gradient(90deg, #E83D3D 0%, rgba(255, 255, 255, 0.5) 50%)",
                  }
            }
          >
            Remove Mapping
          </button>
        </div>
      </div>
    </div>
  );
}
